module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r9n2n5n-5202f0cbf9557f8a4adee8207ae3ee19.svg";